import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import CustomerActionsMenu from './CustomerActionsMenu';
import { Box } from '@mui/material';
import CustomPagination from '../../../components/customPagination';
import { useGetCustomersHandler } from '../dataHandlers/getCustomersHandler';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { useNavigate } from 'react-router-dom';

const CustomersTable = ({ handlePaginationChange, searchQuery = {} }) => {
  const { customers, totalDocuments, isLoading } = useGetCustomersHandler({ searchQuery });
  const { customers: c } = useTranslatedMessages();
  const navigate = useNavigate();
  const col = c.table.columns;
  const na = c.table.not_available;

  const handleRowClick = (params) => {
    if (params.row?.profile_id) {
      navigate(`/customers/${params.row.profile_id}`);
    }
  };

  const columns = [
    {
      field: 'name',
      headerName: col.name,
      flex: 1,
    },
    {
      field: 'email',
      headerName: col.contact_info,
      flex: 1,
      renderCell: (params) => {
        const contacts = [];
        if (params.row.email) contacts.push(params.row.email);
        if (params.row.telephone) contacts.push(params.row.telephone);
        return contacts.join(' / ') || na;
      },
    },
    {
      field: 'peppol_participant',
      headerName: col.peppol_id,
      flex: 1,
      renderCell: (params) => {
        const { endpoint_id, endpoint_scheme_id } = params.row;
        return endpoint_id && endpoint_scheme_id ? `${endpoint_scheme_id}:${endpoint_id}` : '-';
      },
    },
    {
      field: 'company_id',
      headerName: col.business_identifier,
      flex: 1,
    },
    {
      field: 'address',
      headerName: col.country,
      flex: 1,
      renderCell: (params) => {
        const address = params.row.postal_address;
        if (!address) return na;
        return `${address.country}`;
      },
    },
    {
      field: 'type',
      headerName: col.type,
      flex: 1,
    },
    {
      field: 'actions',
      headerName: col.actions,
      flex: 0.5,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Box
            onClick={(event) => event.stopPropagation()}
            sx={{ display: 'flex', alignItems: 'center', width: '100%', height: '100%' }}
          >
            <CustomerActionsMenu customer={params.row} />
          </Box>
        );
      },
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={customers}
        columns={columns}
        getRowId={(row) => row.id}
        paginationMode="server"
        rowCount={totalDocuments}
        loading={isLoading}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onRowClick={handleRowClick}
        onPaginationModelChange={(model) => {
          handlePaginationChange(model.page, model.pageSize);
        }}
        sx={{
          '& .MuiDataGrid-row': {
            cursor: 'pointer',
          },
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default CustomersTable;
